import React from 'react';
import { Form, Input, TextArea } from 'semantic-ui-react';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { firstError, findError } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import fields, { globalFieldLengths } from '@/constants/fields';
import FormValidationError from '@/components/errors/FormValidationError';
import { updateVocabularyEmailProperties } from '../actions';
import { vocabularyFieldLengths } from '../constants';

const VocabularyEmailForm = ({
  cc,
  bcc,
  body,
  subject,
  submitForm,
  updateErrors,
  updateProperties,
  updateStatus,
}) => {
  const intl = useIntl();
  const bccError = findError(updateErrors, 'vocabulary', [fields.BCC_MESSAGE]);
  const bodyError = findError(updateErrors, 'vocabulary', [fields.BODY]);
  const ccError = findError(updateErrors, 'vocabulary', [fields.CC_MESSAGE]);
  const subjectError = findError(updateErrors, 'vocabulary', [fields.SUBJECT]);

  return (
    <div className="content">
      <Form autoComplete="off" onSubmit={submitForm} error={firstError(updateErrors) !== null}>
        <FormValidationError htmlFor="vocabulary_email_cc_value" labelId="save.vocabulary.email.cc" error={ccError}>
          <Input
            id="vocabulary_email_cc_value"
            autoFocus
            disabled={updateStatus === states.PENDING}
            type="custom"
            size="large"
            error={!!ccError}
            placeholder={intl.formatMessage({ id: 'save.vocabulary.email.cc.placeholder' })}
            value={cc}
            onChange={(e) => updateProperties({ cc: e.target.value })}
            maxLength={globalFieldLengths.email}
          />
        </FormValidationError>
        <FormValidationError error={bccError} htmlFor="vocabulary_email_bcc_value" labelId="save.vocabulary.email.bcc">
          <Input
            id="vocabulary_email_bcc_value"
            autoFocus
            disabled={updateStatus === states.PENDING}
            type="custom"
            size="large"
            error={!!bccError}
            placeholder={intl.formatMessage({ id: 'save.vocabulary.email.bcc.placeholder' })}
            value={bcc}
            onChange={(e) => updateProperties({ bcc: e.target.value })}
            maxLength={globalFieldLengths.email}
          />
        </FormValidationError>
        <FormValidationError
          error={subjectError}
          htmlFor="vocabulary_email_subject_value"
          labelId="save.vocabulary.email.subject"
        >
          <Input
            id="vocabulary_email_subject_value"
            error={!!subjectError}
            autoFocus
            disabled={updateStatus === states.PENDING}
            type="custom"
            size="large"
            placeholder={intl.formatMessage({ id: 'save.vocabulary.email.subject.placeholder' })}
            value={subject}
            maxLength={vocabularyFieldLengths.emailSubject}
            onChange={(e) => updateProperties({ subject: e.target.value })}
          />
        </FormValidationError>
        <FormValidationError
          error={bodyError}
          htmlFor="vocabulary_email_body_value"
          labelId="save.vocabulary.email.body"
        >
          <TextArea
            id="vocabulary_email_body_value"
            placeholder={intl.formatMessage({ id: 'save.vocabulary.email.body.placeholder' })}
            disabled={updateStatus === states.PENDING}
            value={body}
            onChange={(e) => updateProperties({ body: e.target.value })}
            rows={10}
            maxLength={vocabularyFieldLengths.emailBody}
          />
        </FormValidationError>
      </Form>
    </div>
  );
};

const mapStateToProps = ({
  vocabularies: {
    activeVocabulary: {
      email: {
        cc, bcc, subject, body,
      }, updateErrors, updateStatus,
    },
  },
}) => ({
  cc,
  bcc,
  subject,
  body,
  updateErrors,
  updateStatus,
});

const mapDispatchToProps = {
  updateProperties: updateVocabularyEmailProperties,
};

export default connect(mapStateToProps, mapDispatchToProps)(VocabularyEmailForm);
